module.exports = __webpack_public_path__ + "static/code-60502c8f90715fd7805d6d29c4eac726.png";